import React from 'react'

// Icons
import PauseIcon from '../icons/pauseIconBlack.inline.svg'
import PlayIcon from '../icons/videoPlayIcon.inline.svg'

// Styles
import * as styles from './limitedControlButtons.module.scss'
interface LimitedControlsButtonProps {
  isPlaying: boolean
  onClick: () => void
}
const LimitedControlButtons = ({ isPlaying, onClick }: LimitedControlsButtonProps) => {
  return (
    <button className={styles.limitedControlsPlayButton} onClick={onClick}>
      {isPlaying ? (
        <div className={styles.pause}>
          <PauseIcon />
        </div>
      ) : (
        <div className={styles.play}>
          <PlayIcon />
        </div>
      )}
    </button>
  )
}
export default LimitedControlButtons
